module.exports = __webpack_public_path__ + "static/media/Self Service Analytics.4c9aff74.svg";